$(document).ready(function(){

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }


    // Check if a custom popup exists in the page DOM
    if (document.querySelector("#custom-popup")) {
        // Variables from popup builder:
        const delay = $('#custom-popup').attr('data-delay');
        const recurring = $('#custom-popup').attr('data-recur');
        const recurAfter = $('#custom-popup').attr('data-recur-after');
        const popupId = $('#custom-popup').attr('data-popup-id');

        // Check if custom popup cookie already exists:
        const customPopupCookieName = 'customPopupCookie-' + popupId
        const customPopupCookie = getCookie(customPopupCookieName);

        // Show popup only if cookie doesn't exist
        if (!customPopupCookie) {
            if (delay) {
                setTimeout(function() {
                    $('#custom-popup').modal('show');
                }, delay);
            } else {
                $('#custom-popup').modal('show');
            }
        }

        // Set cookie when popup is closed
        $('#custom-popup').on('hidden.bs.modal', function (e) {
            if (recurring === "true") {
                switch (recurAfter) {
                    case '24Hours':
                        setCookie('customPopupCookie-' + popupId, 'accepted', '1');
                        break;
                    case '7Days':
                        setCookie('customPopupCookie-' + popupId, 'accepted', '7');
                        break;
                    case '30Days':
                        setCookie('customPopupCookie-' + popupId, 'accepted', '30');
                        break;
                    case '1Year':
                        setCookie('customPopupCookie-' + popupId, 'accepted', '365');
                        break;
                }
            } else {
                setCookie('customPopupCookie-' + popupId, 'accepted', '10000');
            }
        })

    }

});